import { createAction, createReducer } from '@reduxjs/toolkit';
import { today } from '../../../../../utils/dates';
import { IInitialState } from './interface';

const INITIAL_STATE: IInitialState = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: 'todos',
  ownership: 'todos',
  status: 'todos',
  account: 'global',
  initialDate: '2020-01-01',
  finance: undefined,
  finalDate: today(),
  searched: {
    partner: 'todos',
    account: 'global',
    ownership: 'todos',
    status: 'todos',
    initialDate: '2020-01-01',
    finalDate: today(),
  },
};

export const settingFilter = createAction('@clientsApp/filter/SETTING_FILTER');

export const setPartnerFilterOptions = createAction<any>(
  '@clientsApp/filter/SET_PARTNER_FILTER_OPTION'
);
export const setOwnershipFilterOptions = createAction<any>(
  '@clientsApp/filter/SET_OWNERSHIP_FILTER_OPTION'
);
export const setStatusFilterOptions = createAction<any>(
  '@clientsApp/filter/SET_STATUS_FILTER_OPTION'
);
export const setAccountFilterOptions = createAction<any>(
  '@clientsApp/filter/SET_ACCOUNT_FILTER_OPTION'
);
export const setInitialDateFilterOptions = createAction<any>(
  '@clientsApp/filter/SET_INITIAL_DATE_FILTER_OPTION'
);
export const setFinalDateFilterOptions = createAction<any>(
  '@clientsApp/filter/SET_FINAL_DATE_FILTER_OPTION'
);
export const setSearched = createAction<any>('@clientsApp/filter/SET_SEARCHED');

export const gotError = createAction('@clientsApp/filter/GOT_ERROR');

const clientsFilterReducer = createReducer(INITIAL_STATE, {
  [settingFilter.type]: (state) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [setPartnerFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    partner: action.payload,
  }),
  [setOwnershipFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    ownership: action.payload,
  }),
  [setStatusFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    status: action.payload,
  }),
  [setAccountFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    account: action.payload,
  }),
  [setInitialDateFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    initialDate: action.payload,
  }),
  [setFinalDateFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    finalDate: action.payload,
  }),
  [setSearched.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    searched: {
      partner: action.payload.partner,
      ownership: action.payload.ownership,
      account: action.payload.account,
      initialDate: action.payload.initialDate,
      finalDate: action.payload.finalDate,
      status: action.payload.status,
    },
  }),
  [gotError.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default clientsFilterReducer;
